import { useQuery } from "@apollo/client";
import { PastDueSubscriptionQuery } from "../graphql";
import type {
  PastDueSubscriptionQueryType,
  PastDueSubscriptionQueryVariablesType,
} from "@/types/graphql/site.generated";

/**
 * Просроченная (PAST_DUE) подписка зрителя на продукт или null. Гостю и для
 * не подписочного продукта запрос не отправляется (skip).
 */
export function usePastDueSubscription(
  productId: string,
  { skip }: { skip?: boolean } = {},
): { id: string; cardUpdateAllowed: boolean } | null {
  const { data } = useQuery<
    PastDueSubscriptionQueryType,
    PastDueSubscriptionQueryVariablesType
  >(PastDueSubscriptionQuery, { variables: { productId }, skip });
  return data?.mySubscriptions.nodes[0] ?? null;
}
